import Faq01 from "./Faq01";

function main() {
  return (
    <div>
      <Faq01 />
    </div>
  );
}

export default main;
